module.exports = __webpack_public_path__ + "static/media/aurora-network.0b5d697e.svg";